import React, {useState, useEffect} from 'react';
import {
    Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Button,
    CircularProgress,
    Box,
    FormControlLabel,
    Checkbox,
} from '@mui/material';
import {toast} from 'react-toastify';
import 'react-date-range/dist/styles.css';
import useApi from '../../../hooks/useApi';
import StatisticsCheckbox from '../../../components/date/StatisticsCheckbox';
import SelectMulti from '../../../components/select/SelectMulti';
import 'react-date-range/dist/theme/default.css';
import {sendDataToApi} from '../../../API/apiHelper';
import KeyboardDoubleArrowDownOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowDownOutlined';
import {
    fetchSuggestedBundleStatisticFields,
    getUniqueUrls,
    getUniqueTypes,
    getUniqueGenres,
    getUniqueDomains,
} from '../../../API/AdtimizerReport';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import BackupTableOutlinedIcon from '@mui/icons-material/BackupTableOutlined';
import DateRangeSelector from '../../../components/date/DateRangeSelector';

function SuggestedBundlePanelOptions({onSubmit}) {
    const {data: statistics, loading: loadingStats} = useApi(fetchSuggestedBundleStatisticFields);
    const [loading, setLoading] = useState(false);
    const [openEditCompany, setOpenEditCompany] = useState(false);

    const [showUrls, setShowUrls] = useState(false);
    const [showTypes, setShowTypes] = useState(false);
    const [showGenres, setShowGenres] = useState(false);
    const [showDomains, setShowDomains] = useState(false);

    const {data: uniqUrls, loading: loadingUrls} = useApi(getUniqueUrls);
    const {data: uniqTypes, loading: loadingTypes} = useApi(getUniqueTypes);
    const {data: uniqGenres, loading: loadingGenres} = useApi(getUniqueGenres);
    const {data: uniqDomains, loading: loadingDomains} = useApi(getUniqueDomains);

    const [selectedUrlsFilter, setSelectedUrlsFilter] = useState([]);
    const [selectedTypesFilter, setSelectedTypesFilter] = useState([]);
    const [selectedGenresFilter, setSelectedGenresFilter] = useState([]);
    const [selectedDomainsFilter, setSelectedDomainsFilter] = useState([]);

    const today = new Date();
    today.setDate(today.getDate() + 1);
    today.setHours(0, 0, 0, 0);

    const twoWeeksAgo = new Date();
    twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 6);
    twoWeeksAgo.setHours(0, 0, 0, 0);

    const [options, setOptions] = useState({
        start_date: twoWeeksAgo,
        end_date: today,
        stats: [],
        urls: [],
        types: [],
        genres: [],
        domains: [],
    });

    useEffect(() => {
        console.log(uniqUrls)
    }, [uniqUrls]);

    const [editCompany, setEditCompany] = useState([]);

    const handleSubmit = async (event) => {
        onSubmit(options);
    };

    const handleCheckboxChangeStat = (event) => {
        const {name, checked} = event.target;
        let stats = [...options.stats];

        if (checked) {
            stats.push(name);
        } else {
            stats = stats.filter((satat) => satat !== name);
        }

        setOptions({...options, stats});
    };

    const [selectedRange, setSelectedRange] = useState({
        startDate: new Date(options.start_date),
        endDate: new Date(options.start_date),
        key: 'selection',
    });

    const handleDateChange = (event) => {
        const endDate = new Date(event.endDate);
        endDate.setHours(12, 12, 12, 12);
        const endDateISOString = endDate.toISOString().split('T')[0];

        const startDate = new Date(event.startDate);
        startDate.setHours(12, 12, 12, 12);
        const startDateISOString = startDate.toISOString().split('T')[0];

        setSelectedRange((prevSelectedRange) => ({
            ...prevSelectedRange,
            startDate: new Date(startDateISOString),
            endDate: new Date(endDateISOString),
            key: 'selection',
        }));

        if (endDate && startDate) {
            setOptions((prevOptions) => ({
                ...prevOptions,
                start_date: startDateISOString,
                end_date: endDateISOString,
            }));
        }
    };

    useEffect(() => {
        setOptions((prevOptions) => ({
            ...prevOptions,
            urls: selectedUrlsFilter,
        }));
    }, [selectedUrlsFilter]);

    useEffect(() => {
        setOptions((prevOptions) => ({
            ...prevOptions,
            types: selectedTypesFilter,
        }));
    }, [selectedTypesFilter]);

    useEffect(() => {
        setOptions((prevOptions) => ({
            ...prevOptions,
            genres: selectedGenresFilter,
        }));
    }, [selectedGenresFilter]);

    useEffect(() => {
        setOptions((prevOptions) => ({
            ...prevOptions,
            domains: selectedDomainsFilter,
        }));
    }, [selectedDomainsFilter]);

    return (
        <Grid container spacing={2} sx={{width: "100%", marginLeft: '0px',}}>
            <Accordion sx={{width: "100%"}}>
                <AccordionSummary
                    expandIcon={<KeyboardDoubleArrowDownOutlinedIcon/>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    sx={{backgroundColor: '#f0f3f5', width: "100%"}}
                >
                    Options
                </AccordionSummary>
                <AccordionDetails sx={{width: "100%"}}>
                    <Grid item xs={12} md={12} sx={{width: "100%"}}>
                        <form>
                            <Grid item xs={12} md={12} sx={{width: "100%", margin: '0px 0 25px auto'}}>
                                <Grid item xs={12} md={12}>
                                    {Object.keys(statistics).length != 0 ? (<strong>Data</strong>) : ''}
                                </Grid>
                                {statistics?.map((statistic) => (
                                    <StatisticsCheckbox
                                        key={statistic.key}
                                        statistic={statistic}
                                        checked={options.stats.includes(statistic.key)}
                                        onChange={handleCheckboxChangeStat}
                                    />
                                ))}
                            </Grid>

                            <Grid item xs={12} md={12} sx={{width: "100%", margin: '25px 0 25px auto'}}>
                                <Grid item xs={12} md={12}>
                                    <strong>Filters</strong>
                                </Grid>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={12}>
                                        {Object.keys(uniqUrls).length != 0 ? (<FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={showUrls}
                                                    onChange={() => setShowUrls(!showUrls)}
                                                    name="Urls"
                                                />
                                            }
                                            label="Urls"
                                        />) : ''}

                                        {Object.keys(uniqTypes).length != 0 ? (<FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={showTypes}
                                                    onChange={() => setShowTypes(!showTypes)}
                                                    name="Types"
                                                />
                                            }
                                            label="Types"
                                        />) : ''}

                                        {Object.keys(uniqGenres).length != 0 ? (<FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={showGenres}
                                                    onChange={() => setShowGenres(!showGenres)}
                                                    name="Genres"
                                                />
                                            }
                                            label="Genres"
                                        />) : ''}

                                        {Object.keys(uniqDomains).length != 0 ? (<FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={showDomains}
                                                    onChange={() => setShowDomains(!showDomains)}
                                                    name="Domains"
                                                />
                                            }
                                            label="Domains"
                                        />) : ''}
                                    </Grid>

                                    <Grid item xs={6}>
                                        {showUrls && (
                                            <SelectMulti
                                                label="Urls"
                                                items={uniqUrls}
                                                selectedItems={selectedUrlsFilter}
                                                onChange={(event) => setSelectedUrlsFilter(event.target.value)}
                                                itemLabel="value"
                                                itemKey="value"
                                                itemValue="value"
                                            />
                                        )}
                                    </Grid>

                                    <Grid item xs={6}>
                                        {showTypes && (
                                            <SelectMulti
                                                label="Types"
                                                items={uniqTypes}
                                                selectedItems={selectedTypesFilter}
                                                onChange={(event) => setSelectedTypesFilter(event.target.value)}
                                                itemLabel="value"
                                                itemKey="value"
                                                itemValue="value"
                                            />
                                        )}
                                    </Grid>
                                    <Grid item xs={6}>
                                        {showGenres && (
                                            <SelectMulti
                                                label="Genres"
                                                items={uniqGenres}
                                                selectedItems={selectedGenresFilter}
                                                onChange={(event) => setSelectedGenresFilter(event.target.value)}
                                                itemLabel="value"
                                                itemKey="value"
                                                itemValue="value"
                                            />
                                        )}
                                    </Grid>
                                    <Grid item xs={6}>
                                        {showDomains && (
                                            <SelectMulti
                                                label="Domains"
                                                items={uniqDomains}
                                                selectedItems={selectedDomainsFilter}
                                                onChange={(event) => setSelectedDomainsFilter(event.target.value)}
                                                itemLabel="value"
                                                itemKey="value"
                                                itemValue="value"
                                            />
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    </Grid>
                </AccordionDetails>
            </Accordion>
            <Grid item xs={6} md={6}>
                <Button
                    size={"large"}
                    startIcon={<BackupTableOutlinedIcon fontSize="small"/>}
                    onClick={handleSubmit}
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{marginLeft: '-15px', marginBottom: '15px'}}
                >
                    Generate Report
                </Button>
            </Grid>
            {loading &&
                <Grid item xs={12} md={12}>
                    <Box justifyContent="center" textAlign={"center"} alignItems="center">
                        <CircularProgress size={200}/>
                    </Box>
                </Grid>}

            <Grid item xs={6} md={6}>
                <DateRangeSelector
                    initialRange={{startDate: twoWeeksAgo, endDate: today, key: 'selection'}}
                    onRangeChange={handleDateChange}
                />
            </Grid>
        </Grid>
    );
}

export default SuggestedBundlePanelOptions;
